// 商品データ（MainContent.js から共通化 — 2D/3D 両方で使う）
const products = [
  {
    id: 'guatemala-honey',
    name: 'Guatemala Honey',
    nameJa: 'グアテマラハニー',
    farm: 'Lus Nueces農園',
    weight: '150g',
    price: '¥1,400',
    desc: '甘みとフルーティーな香り、ワインのような後味',
    img: 'https://baseec-img-mng.akamaized.net/images/item/origin/b6d4133a9b3b3a5994c5c5573662fb13.png',
    url: 'https://guricoffee.base.shop/items/135099859',
  },
  {
    id: 'guatemala-shb',
    name: 'Guatemala SHB',
    nameJa: 'グアテマラSHB',
    farm: '',
    weight: '150g',
    price: '¥1,000',
    desc: 'カカオのような甘みとしっかりした深煎りの味わい',
    img: 'https://baseec-img-mng.akamaized.net/images/item/origin/4fb5f0a2234c452f6dacd2323e64b3f6.png',
    url: 'https://guricoffee.base.shop/items/111760508',
  },
  {
    id: 'subscription',
    name: 'Monthly Subscription',
    nameJa: '定期便',
    farm: 'Lus Nueces農園',
    weight: '300g / 月',
    price: '¥2,520',
    desc: '毎月届く、10%OFFの送料無料定期便',
    img: 'https://baseec-img-mng.akamaized.net/images/item/origin/b6d4133a9b3b3a5994c5c5573662fb13.png',
    url: 'https://guricoffee.base.shop/items/84809126',
  },
];

export default products;
